module.exports = __webpack_public_path__ + "static/media/photography-icon.1fe1eb68.png";